import React, { useEffect, useState } from "react";
import TitleUnderlined from "../../components/TitleUnderlined";
import Breadcrumb from "../../components/Breadcrumb";
import Row from "../../components/Row";
import Column from "../../components/Column";
import APIInterface from "../../tools/APIInterface";
import { RoutesWeb } from "../../tools/RoutesWeb";

const DecanatoLoadsView = () => {
    const token = localStorage.getItem('tokenAdmin');
    const [filters, setFilters] = useState({
        decanato: '',
        period_year: new Date().getFullYear(),
        period_quincena: '',
    });
    const [result, setResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleFilter = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value,
        });
    };

    const fetchDecanatoLoads = (filtersToUse = filters) => {
        setIsLoading(true);
        APIInterface.decanatoLoadsAdmin(token, filtersToUse)
        .then((response) => {
            setResult(response.data);
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            setIsLoading(false);
        });
    };

    useEffect(() => {
        fetchDecanatoLoads({
            decanato: '',
            period_year: new Date().getFullYear(),
            period_quincena: '',
        });
        // Carga inicial al entrar a la vista.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        fetchDecanatoLoads();
    };

    return (
        <div className="pt-5 pb-5">
            <br />
            <br />
            <Breadcrumb items={[
                { title: 'Dashboard', route: RoutesWeb.ADMIN_DASHBOARD },
                { title: 'Historial de Cargas', active: true },
            ]} />
            <TitleUnderlined>Historial de <span className="embercom_overlined">Cargas Decanatos</span></TitleUnderlined>
            <br />
            <form onSubmit={handleSearch}>
                <Row>
                    <Column className="col-md-3">
                        <label className="semibold">Decanato</label>
                        <select className="form-control" name="decanato" value={filters.decanato} onChange={handleFilter}>
                            <option value="">Todos</option>
                            {[...Array(14)].map((_, idx) => (
                                <option key={idx} value={(idx + 1).toString()}>{idx + 1}</option>
                            ))}
                            <option value="Staff">Staff</option>
                            <option value="Equipo Evento">Equipo Evento</option>
                            <option value="Vida Consagrada">Vida Consagrada</option>
                        </select>
                    </Column>
                    <Column className="col-md-3">
                        <label className="semibold">Año</label>
                        <input className="form-control" type="number" name="period_year" value={filters.period_year} onChange={handleFilter} />
                    </Column>
                    <Column className="col-md-3">
                        <label className="semibold">Quincena</label>
                        <select className="form-control" name="period_quincena" value={filters.period_quincena} onChange={handleFilter}>
                            <option value="">Todas</option>
                            <option value="1">Primera</option>
                            <option value="2">Segunda</option>
                        </select>
                    </Column>
                    <Column className="col-md-3 d-flex align-items-end">
                        <button className="btn btn-main w-100" type="submit">{isLoading ? 'Consultando...' : 'Consultar'}</button>
                    </Column>
                </Row>
            </form>
            <br />
            <table className="table">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Decanato</th>
                        <th>Quincena</th>
                        <th>Lider</th>
                        <th>Inscritos</th>
                        <th>Boletos</th>
                        <th>Adjunto</th>
                    </tr>
                </thead>
                <tbody>
                    {result && result.data && result.data.length > 0 ? result.data.map((load) => (
                        <tr key={load.id}>
                            <td>{new Date(load.registered_at).toLocaleString()}</td>
                            <td>{load.decanato}</td>
                            <td>{load.period_year} - {load.period_quincena}</td>
                            <td>{load.user ? load.user.name : '-'}</td>
                            <td>{load.attendees_count}</td>
                            <td>
                                <a
                                    href={`${process.env.REACT_APP_API_URL}/boletos/${load.order_id}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Descargar PDF
                                </a>
                            </td>
                            <td>
                                <a href={`${process.env.REACT_APP_API_URL}${load.attachment_url}`} target="_blank" rel="noreferrer">Ver archivo</a>
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan="7">{isLoading ? 'Cargando resultados...' : 'Sin resultados'}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default DecanatoLoadsView;

